import { render, staticRenderFns } from "./item-select.vue?vue&type=template&id=0a16f7d9&scoped=true&"
import script from "./item-select.vue?vue&type=script&lang=js&"
export * from "./item-select.vue?vue&type=script&lang=js&"
import style0 from "./item-select.vue?vue&type=style&index=0&id=0a16f7d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a16f7d9",
  null
  
)

export default component.exports